module.exports = __webpack_public_path__ + "img/just-sold-header.a0c4e28e.png";